export const AI_SUGGESTION_KEYS = [
  'ai-assistant.suggestions.items.buses-not-charged-yesterday',
  'ai-assistant.suggestions.items.chargers-current-issues',
];
